export const GET_MENU_ITEM = "GET_MENU_ITEM";
export const STORE_HEADER = "STORE_HEADER";
export const STORE_FOOTER = "STORE_FOOTER";
export const STORE_SOCIAL_MEDIA = "STORE_SOCIAL_MEDIA";
export const GET_FOOTER_FAQS = "GET_FOOTER_FAQS";
export const GET_FOOTER_FAQS_SUCCESS = "GET_FOOTER_FAQS_SUCCESS";
